export const LOAD_DATA = 'LOAD_DATA';
export const SET_MAX_DISTANCE = 'SET_MAX_DISTANCE';
export const SET_SORT_BY = 'SET_SORT_BY';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_MOBILE_FILTERS_OPENED = 'SET_MOBILE_FILTERS_OPENED';
